import { Link } from 'react-router-dom'
import ProseCard from './ProseCard'
import ConnectionDetails from '../features/home/ConnectionDetails'
import LeakDiagram from '../features/home/LeakDiagram'
import { useRdns, useSelf } from '../hooks/useSelf'
import { home } from '../content/site'
import styles from './Home.module.css'

export default function Home() {
    const self = useSelf()
    const rdns = useRdns(self.data?.ip)

    return (
        <>
            <section className={styles.hero}>
                <h1 className={styles.title}>{home.heading}</h1>
                <p className={styles.lede}>{home.lede}</p>

                {/* The action comes before the connection panel, not after it.
                    The panel is tall enough (tabs plus a map) to push a CTA below
                    the fold, and pressing this is why people are here.
                    A link, not a button: nesting an <a> in a <button> is invalid
                    HTML and gives one action two tab stops. */}
                <div className={styles.ctaRow}>
                    <Link to="/dns-leak-test" className={styles.cta}>{home.cta}</Link>
                    <span className={styles.muted}>{home.ctaNote}</span>
                </div>
            </section>

            <ConnectionDetails
                self={self.data}
                rdns={rdns.data}
                rdnsPending={rdns.isPending && rdns.fetchStatus !== 'idle'}
                loading={self.isPending}
                error={self.isError}
            />

            {/* illustrate the concept before the cards explain it in words */}
            <section className={styles.diagram}>
                <LeakDiagram />
            </section>

            <div className={styles.grid}>
                <ProseCard heading={home.privacy.heading} body={home.privacy.body} />
                <ProseCard heading={home.whatIsALeak.heading} body={home.whatIsALeak.body} />
                <ProseCard heading={home.whyUs.heading} body={home.whyUs.body} />
            </div>
        </>
    )
}
